var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87598 12.5C9.11963 12.5 10.9385 10.6812 10.9385 8.4375C10.9385 6.19384 9.11963 4.375 6.87598 4.375C4.63232 4.375 2.81348 6.19384 2.81348 8.4375C2.81348 10.6812 4.63232 12.5 6.87598 12.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3086 4.52344C11.6677 4.42604 12.0381 4.37613 12.4102 4.375C13.4876 4.375 14.5209 4.80301 15.2828 5.56488C16.0446 6.32675 16.4727 7.36006 16.4727 8.4375C16.4727 9.51494 16.0446 10.5483 15.2828 11.3101C14.5209 12.072 13.4876 12.5 12.4102 12.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25098 15.4219C1.88531 14.5192 2.72757 13.7825 3.70661 13.2739C4.68565 12.7653 5.77271 12.4998 6.87598 12.4998C7.97924 12.4998 9.06631 12.7653 10.0453 13.2739C11.0244 13.7825 11.8666 14.5192 12.501 15.4219",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4102 12.5C13.5135 12.4993 14.6008 12.7645 15.5799 13.2731C16.5591 13.7817 17.4013 14.5188 18.0352 15.4219",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.f03a46b9677cdb9fe1b28af82e213b99.svg";
export { ForwardRef as ReactComponent };